import { MultiComboboxBase } from './MultiComboboxBase'
import { SingleComboboxBase } from './SingleComboboxBase'
import type { ComboboxProps } from './types'

export function ComboboxBase<T = string>(props: ComboboxProps<T>) {
  if (props.multiple === true) {
    return <MultiComboboxBase<T> {...props} />
  }
  return <SingleComboboxBase<T> {...props} />
}
